var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSelectionDay(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 458,
    height: 106,
    viewBox: "0 0 458 106",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_1179_9932)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M42.4174 27.971C42.7788 27.3686 43.4299 27 44.1324 27H412.905C413.587 27 414.222 27.3475 414.59 27.9219L429.31 50.9219C429.731 51.5791 429.731 52.4209 429.31 53.0781L414.59 76.0781C414.222 76.6525 413.587 77 412.905 77H44.1324C43.4299 77 42.7788 76.6314 42.4174 76.029L28.6174 53.029C28.2374 52.3956 28.2374 51.6044 28.6174 50.971L42.4174 27.971Z",
    fill: "#8CE7A0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.0449 49.4275L28.6174 50.971L26.0449 49.4275C25.0949 51.0109 25.0949 52.9891 26.0449 54.5725L39.8449 77.5725L42.4174 76.029L39.8449 77.5725C40.7485 79.0785 42.3761 80 44.1324 80H412.905C414.61 80 416.198 79.1312 417.117 77.6954L414.59 76.0781L417.117 77.6953L431.837 54.6953C432.888 53.0523 432.888 50.9477 431.837 49.3047L417.117 26.3047C416.198 24.8687 414.61 24 412.905 24H44.1324C42.3761 24 40.7485 24.9215 39.8449 26.4275L26.0449 49.4275Z",
    stroke: "white",
    strokeWidth: 6
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_1179_9932",
    x: 0.332031,
    y: 0,
    width: 457.293,
    height: 106,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 11
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.256486 0 0 0 0 0.510433 0 0 0 0 0.251303 0 0 0 0.03 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1179_9932"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1179_9932",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSelectionDay);
export default __webpack_public_path__ + "static/media/selection-day.25767530ff9e713ba07f01bed720631d.svg";
export { ForwardRef as ReactComponent };